module.exports = __webpack_public_path__ + "static/tattoo2-899881edd77298f1f34ba5f4fe1e37e4.jpg";